"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentNotFoundError = void 0;
var ContentNotFoundError = /** @class */ (function (_super) {
    __extends(ContentNotFoundError, _super);
    function ContentNotFoundError(contentItem) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "Content item \"".concat(contentItem, "\" was not found")) || this;
        _this.contentItem = contentItem;
        _this.name = 'CONTENT_NOT_FOUND';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return ContentNotFoundError;
}(Error));
exports.ContentNotFoundError = ContentNotFoundError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudE5vdEZvdW5kRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbnRlbnQvbW9kZWwvQ29udGVudE5vdEZvdW5kRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7SUFBMEMsd0NBQUs7SUFHN0MsOEJBQW1CLFdBQW1COztRQUF0QyxZQUNFLGtCQUFNLHlCQUFpQixXQUFXLHFCQUFpQixDQUFDLFNBRXJEO1FBSGtCLGlCQUFXLEdBQVgsV0FBVyxDQUFRO1FBRnRCLFVBQUksR0FBRyxtQkFBbUIsQ0FBQztRQUl6QyxNQUFNLENBQUMsY0FBYyxDQUFDLEtBQUksRUFBRSxXQUFXLFNBQVMsQ0FBQyxDQUFDOztJQUNwRCxDQUFDO0lBQ0gsMkJBQUM7QUFBRCxDQUFDLEFBUEQsQ0FBMEMsS0FBSyxHQU85QztBQVBZLG9EQUFvQiJ9